import { mediaCdn } from '../../Player/Helpers'

/** the ad-block and geo screens' pictures, from Cloudinary as everywhere else */
const AD_BLOCK_HAND = 'v1792568096/adblock-hand_wbsa9u.webp'

export const STORIES_IMAGES = {
  adBlockHand: `${mediaCdn}f_auto,q_auto/${AD_BLOCK_HAND}`,
  /** the 20px mark before each cause */
  adBlockHandMark: `${mediaCdn}f_auto,q_auto,c_scale,w_40/${AD_BLOCK_HAND}`,
  geoMark: `${mediaCdn}f_auto,q_auto/v1792568096/geo-13_zxfapc.webp`,
  /** shown 40px wide (desktop 60) */
  geoLogo: `${mediaCdn}f_auto,q_auto,c_scale,w_120/v1792568096/logo-13-white_loecuc.webp`,
}
